import type { FaqTypeEnum, ThemedFaqItem, ThemedFaqRawResponse } from '@models/faq';
import type { Options } from '@wizbii-utils/angular/webservices';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { fromFaqRawResponseToThemedFaqItems } from '@models/faq';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ThemedFaqServiceConfig {
  baseUrl: string;
  lang: string;
}

export const THEMED_FAQ_SERVICE_CONFIG = new InjectionToken<ThemedFaqServiceConfig>('THEMED_FAQ_SERVICE_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class ThemedFaqService {
  readonly #config = inject(THEMED_FAQ_SERVICE_CONFIG);
  readonly #http = inject(HttpClient);

  //TODO move to utils
  getItems(type: FaqTypeEnum, options?: Options): Observable<ThemedFaqItem[]> {
    return this.#http
      .get<ThemedFaqRawResponse>(`${this.#config.baseUrl}/${type}`, {
        ...options,
        params: {
          // eslint-disable-next-line @typescript-eslint/no-misused-spread
          ...options?.params,
          locale: this.#config.lang,
          'populate[0]': 'faq_articles',
        },
      })
      .pipe(
        map((response) => {
          return fromFaqRawResponseToThemedFaqItems(response);
        }),
        catchError(() => of([]))
      );
  }
}
